import { render } from "./createCustomer.vue?vue&type=template&id=06c9be50"
import script from "./createCustomer.vue?vue&type=script&lang=js"
export * from "./createCustomer.vue?vue&type=script&lang=js"

import "./createCustomer.vue?vue&type=style&index=0&id=06c9be50&lang=css"

import exportComponent from "/Users/1M/Projects/SLE/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__